import React, { useEffect, useRef, useState } from 'react'
import { Card, Form, Button, Toast } from '@douyinfe/semi-ui';
import './index.scss'
import request from '../../utils/request';
import { useZxContext } from '../../zxContext';
import { useNavigate } from 'react-router-dom';

const Index = () => {
	const { setLogin, isLogin, setUserinfo, userinfo, tags, activeTagId } = useZxContext()
	const [saveLoading, setSaveLoading] = useState(false)
	const navigate = useNavigate()
	const formApi = useRef()
	const [msgCode, setMsgCode] = useState('发送验证码')
	const [codeBtnDisabled, setCodeBtnDisabled] = useState(false)
	const codeInterval = useRef()
	const mobileRef = useRef()


	useEffect(() => {
		if (isLogin) {
			if (tags.length > 0 && activeTagId) {
				const targetTab = tags.filter((e) => e.id === activeTagId)
				navigate(targetTab[0].path)
			} else {
				if (userinfo.role === 0) {
					navigate('/dashboard/learn', { replace: true, })
				} else if (userinfo.role === 1) {
					navigate('/unit/dashboard/learn', { replace: true })
				}
			}
		}
	}, [isLogin, userinfo, tags])


	useEffect(() => {


    return () => {
      // console.log('clear', codeInterval.current)
      clearInterval(codeInterval.current)
    }
  }, [])


	return <div className='login'>
		<div className='box'>
			<div className='logo'>

			</div>
			<Card headerLine bodyStyle={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'center',
				height: '100%',
				boxSizing: 'border-box',
				maxHeight: 442,

			}} >
				<div style={{ color: 'rgb(68,153,255)', display: 'flex', width: '100%', alignItems: 'center', }}>
					<div style={{ backgroundColor: 'rgb(68,153,255)', width: '4px', height: '24px', marginRight: '20px' }} />
					<h1 style={{ fontSize: '26px', fontWeight: 'bold', textAlign: 'left' }}>欢迎登录兰溪智学</h1>
				</div>
				<div >

					<Form
						labelCol={{ span: 2 }}
						labelPosition='left'
						labelAlign='right' style={{ width: 360, }} ref={formApi} >
						<Form.Input field='account' label={{ text: '账号', style: { color: 'var(--semi-color-text-0)', fontWeight: '400' } }} placeholder='输入账号' rules={[
							{ required: true, message: '账号不能为空' },
							{ type: 'string', message: '字符串类型' },
						]}></Form.Input>
						<Form.Input field='password' label={{ text: '密码', style: { color: 'var(--semi-color-text-0)', fontWeight: '400' } }} mode='password' showClear placeholder='输入密码' rules={[
							{ required: true, message: '密码不能为空' },
							{ type: 'string', message: '字符串类型' },
						]}></Form.Input>
						<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
							<Form.Input ref={mobileRef} field='mobile' label={{ text: '手机号码', style: { color: 'var(--semi-color-text-0)', fontWeight: '400' } }} placeholder='输入手机号码' showClear rules={[
								{ required: true, message: '手机号不能为空' },
								{ type: 'string', message: '字符串类型' },
							]} />
							<Button style={{minWidth:94}} disabled={codeBtnDisabled} theme='solid' type='secondary' onClick={async () => {
								try {
									var captcha = new window.TencentCaptcha('194753887', async res => {
										if (res.ret === 0) {
											setCodeBtnDisabled(true)
											// console.log(mobileRef.current.value)
											const response = await request({ url: '/api/auth/captcha', method: 'post', body: {mobile:mobileRef.current.value, ticket:res.ticket,randstr:res.randstr} })

											if (response.msg === false) {
												// setSaveLoading(false)
												setCodeBtnDisabled(false)
												Toast.error(response.result.err)
												return
											}

											Toast.success(response.result)
											let t = 60
											codeInterval.current = setInterval(() => {
												t--
												if (t <= 0) {
													setMsgCode('发送验证码')
													setCodeBtnDisabled(false)
													clearInterval(codeInterval.current)
								
												} else {
													setMsgCode(t + 's')
												}
								
											}, 1000)
										}

									}, {});

									formApi.current.formApi.validate(['mobile'])
										.then(values => {
											console.log(values)
											// setMobile(values.mobile)
											captcha.show();
										}).catch(error => {
										});
	

								} catch (e) {

									console.log(e)

								}

							}}>{msgCode}</Button>
						</div>
						<Form.Input field='msg_code' label={{ text: '验证码', style: { color: 'var(--semi-color-text-0)', fontWeight: '400' } }} showClear placeholder='输入验证码' rules={[
							{ required: true, message: '验证码不能为空' },
							{ type: 'string', message: '字符串类型' },
						]}></Form.Input>
						<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
							<Form.Checkbox noLabel field='auto'>记住密码</Form.Checkbox>
							{/* <span style={{ color: 'rgb(68,153,255)'}}>忘记密码?</span> */}
							<Button theme='borderless' type='secondary'>忘记密码</Button>
						</div>
						<div>
							<Button disabled={saveLoading} style={{ backgroundColor: 'rgb(68,153,255)', }} theme='solid' block loading={saveLoading} onClick={async () => {
								try {
									setSaveLoading(true)
									const values = await formApi.current.formApi.validate()
									const response = await request({ url: '/api/auth/login', method: 'post', body: values })

									if (response.msg === false) {
										setSaveLoading(false)
										Toast.error(response.result.err)
										return
									}
									setLogin(true)
									setUserinfo(response.result.userinfo)
									Toast.success(response.result.msg)

								} catch (e) {
									console.log(e)
									setSaveLoading(false)
								}


							}} >立即登录</Button>
						</div>
					</Form>

				</div>

			</Card>
		</div>

	</div>
}

export default Index
